
/* Project Import will be here */
import { IOrderUploadParams } from "models/orderModels";
/* Project Import will be here */

export type ISalesReturnProducts = {
    Page: number,
    ReqCode: string
};

export type ISalesReturnUpload = {
    MfgDate: string,
    PId: number,
    PName: string,
    PrincipalId: number,
    Qty: number,
    Reason: string,
    ReasonId: number,
    UomId: number
};

export type ISalesReturnHistoryDetailsParams = {
    SalesReturnId: number
};

export type IExchangeSubmitParams = {
    AddressId: number,
    DeliveryDate: string,
    ExReturn: [ISalesReturnUpload],
    ExOrder: [IOrderUploadParams]
}